import * as React from "react";
const SvgNewRound = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "Button-Play-1--Streamline-Streamline-3.0",
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Button Play 1 Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
	d: "M0.75 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0 -22.5 0",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9 15.61a1.63 1.63 0 0 0 2.71 1.23l4.68 -4.09a1 1 0 0 0 0 -1.5l-4.68 -4.1A1.64 1.64 0 0 0 9 8.38Z",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
})));
export { SvgNewRound as ReactComponent };
